import { render, staticRenderFns } from "./ContactCreateUpdate2.vue?vue&type=template&id=d621eaa6&scoped=true&"
import script from "./ContactCreateUpdate2.vue?vue&type=script&lang=js&"
export * from "./ContactCreateUpdate2.vue?vue&type=script&lang=js&"
import style0 from "./ContactCreateUpdate2.vue?vue&type=style&index=0&id=d621eaa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d621eaa6",
  null
  
)

export default component.exports